import { Stack, Typography } from '@mui/material'

import { DateTime } from 'luxon'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object} props.params
 * @param {Object} props.params.row
 * @param {string} [props.params.formattedValue]
 * @param {Object} props.property
 * @param {string} props.property.timezone
 * @param {boolean} [props.mobileView]
 */
export default function EventListLastModifiedCell({ params, property, mobileView }) {
  const { row, formattedValue } = params

  let modifiedOn = null
  if (row.eventClass === 'NOISE') {
    modifiedOn = row.noiseFeedback?.modifiedOn
  } else if (row.eventClass === 'SMOKE' && row.feedbackOn) {
    modifiedOn = row.smokeFeedback?.modifiedOn || row.feedbackOn
  }

  let createdLuxon = null
  if (modifiedOn) {
    createdLuxon = DateTime.fromISO(modifiedOn, {
      zone: property.timezone,
    })
  }

  return (
    <Stack alignItems={mobileView ? 'end' : null}>
      <Typography
        variant={mobileView ? 'caption' : 'body1'}
        fontSize={mobileView ? 12 : 14}
        whiteSpace="pre-line"
      >
        {row.smokeFeedback?.autocharge && formattedValue === 'N/A'
          ? 'Autocharge'
          : formattedValue}
      </Typography>
      {createdLuxon && (
        <Typography
          variant="caption"
          fontSize={mobileView ? 10 : 12}
          color="grey.500"
          fontWeight={600}
        >
          {createdLuxon.toLocaleString(DateTime.DATETIME_SHORT)}
        </Typography>
      )}
    </Stack>
  )
}
